import { render, staticRenderFns } from "./Dropzone.vue?vue&type=template&id=fd68d8fe&scoped=true&"
import script from "./Dropzone.vue?vue&type=script&lang=ts&"
export * from "./Dropzone.vue?vue&type=script&lang=ts&"
import style0 from "./Dropzone.vue?vue&type=style&index=0&id=fd68d8fe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd68d8fe",
  null
  
)

export default component.exports